import { paginatedQuery } from 'lib-shared-api-utils';
import { ApiResponse } from 'lib-shared-types-api';

import { api } from 'app/app.api';

import {
  CreateDeleteTeamAgentsApiArg,
  ReadTeamAgentsApiArg,
  ReadTeamAgentsApiResponse,
  ReadTeamsApiArg,
  ReadTeamsApiResponse,
} from './types/teamsApi.types';

export const teamsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    readTeams: builder.query<ReadTeamsApiResponse, ReadTeamsApiArg>({
      query: (arg) =>
        paginatedQuery(arg, (arg) => ({
          version: 1,
          path: 'teams',
          params: {
            filter_out_by_queue: arg.filter_out_by_queue,
          },
        })),
    }),
    readTeamAgents: builder.query<
      ReadTeamAgentsApiResponse,
      ReadTeamAgentsApiArg
    >({
      query: (arg) =>
        paginatedQuery(arg, ({ teamId }) => ({
          version: 1,
          path: `teams/${teamId}/agents`,
        })),
    }),
    createTeamAgents: builder.mutation<
      ApiResponse,
      CreateDeleteTeamAgentsApiArg
    >({
      query: ({ team_id, ...body }) => ({
        version: 1,
        path: `teams/${team_id}/agents`,
        method: 'PUT',
        body,
      }),
    }),
    deleteTeamAgents: builder.mutation<
      ApiResponse,
      CreateDeleteTeamAgentsApiArg
    >({
      query: ({ team_id, ...body }) => ({
        version: 1,
        path: `teams/${team_id}/agents`,
        method: 'DELETE',
        body,
      }),
    }),
  }),
});
